<div
  class="menubar-hoverable header-fixed menubar-pin"
  style="
    font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;
    font-size: 13px;
    line-height: 1.846153846;
    color: #313534;
    background-color: #ffffff;
  "
>
  <!-- header -->

  <!-- menu -->

  <div  (click)="closeWingOption()" id="base">
    <div  id="content" class="category-wise-main-container">
      <div
        (click)="collapseColumnOption()"
        class="page-info-with-export-button"
      >
        <div class="page-name-category-wise">
          <span class="report-text-category">{{ 'report'| translate }} </span>
          <span class="report-text-category-main-page">{{
            'categoryWise' | translate
          }}</span>
        </div>
        <div class="export-button-container-category-wise">
          <button
            *ngIf="
              tableRowData &&
              tableRowData.length > 0 &&
              tableColumnData && tableColumnData.length > 0
            "
            (click)="exportReport()"
            class="btn-export-category-wise"
            [disabled]="isExportingReport"
          >
            <i class="ri-download-2-line" *ngIf="!isExportingReport"></i>
            <app-button-loader *ngIf="isExportingReport"></app-button-loader>
            {{ 'export' | translate }}
          </button>
        </div>
      </div>

      <div class="filter-container-category-wise">
        <div
          (click)="collapseColumnOption()"
          [ngClass]="{
            'applied-and-reset-filter-main-container': !isExpanded,
            'applied-and-reset-filter-main-container-active': isExpanded
          }"
        >
          <div
            class="applied-and-reset-filter"
          >
            <div class="filter-applied-on-page">
              <div class="applied-filter-data">
                <span class="filter-text">{{ 'filterBy' | translate }} : </span>
                <div class="filter-applied-labels">
                  <span class="filter-name-text">{{ 'wing' | translate }} :</span>
                  <span class="applied-filter-name-text">{{
                    appliedWing != "All" 
                      ? appliedWing.length + " " + "selected"
                      : ('all' | translate)
                  }}</span>
                </div>
                <div class="filter-applied-labels">
                  <span class="filter-name-text">{{ 'class' | translate }} :</span>
                  <span class="applied-filter-name-text">{{
                    appliedClassStandard != "All"
                      ? appliedClassStandard.length + " " + "selected"
                      : ('all' | translate)
                  }}</span>
                </div>
                <div class="filter-applied-labels">
                  <span class="filter-name-text">{{
                    'section' | translate
                  }} :</span>
                  <span class="applied-filter-name-text">{{
                    appliedClassId != "All"
                      ? appliedClassId.length + " " + "selected"
                      : ('all' | translate)
                  }}</span>
                </div>
                <div class="filter-applied-labels">
                  <span class="filter-name-text">{{ 'caste' | translate }} :</span>
                  <span class="applied-filter-name-text">{{
                    appliedFilterData != null
                      ? appliedFilterData[0].caste
                      : ('all' | translate)
                  }}</span>
                </div>
                <div class="filter-applied-labels">
                  <span class="filter-name-text">{{ 'gender' | translate }} :</span>

                  <span class="applied-filter-name-text">{{
                    appliedFilterData != null
                      ? appliedFilterData[0].gender
                      :( 'all' | translate)
                  }}</span>
                </div>
              </div>
            </div>
            <div class="filter-reset-apply-container">
              <div class="all-buttons-for-filter">
                <div
                  *ngIf="enableReset"
                  (click)="resetFilter()"
                  class="reset-apply-filter"
                >
                  {{ 'reset' | translate }} 
                </div>
                <div class="apply-filter-button">
                  <button
                    class="more-filter-button"
                    *ngIf="!isExpanded"
                    (click)="expandFilters()"
                  >
                    {{ 'moreFilter' | translate }}
                  </button>
                  <button
                    class="less-filter-button"
                    *ngIf="isExpanded"
                    (click)="expandFilters()"
                    style="min-height: 40px;"
                  >
                    {{ 'lessFilter' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div></div>

          <div class="selection-label-main-container">
            <div class="main-container-selection">
              <div class="label-selection">
                {{ 'selectWing' | translate }}
              </div>
              <input
                (click)="openWingOption($event)"
                readonly
                [placeholder]="
                  appliedWing != 'All'
                    ? appliedWing.length + ' selected'
                    :( 'all' | translate)
                "
                class="input-for-wing-selection"
              />
              <span class="dropdown-icon"><i class="ri-arrow-drop-down-line"></i></span>

              <div *ngIf="openOptionForWingSelection" class="option-for-wing">
                <div class="option-name">
                  <input
                  [checked]="getStatusOfWing()"
                    type="checkbox"
                    [id]="78"
                    (click)="selectAllWing($event)"
                  />
                  <label  [for]="78" class="class-category-name-text">{{ 'all' | translate }}</label>
                </div>
                <ng-container *ngFor="let key of wingListData; let i = index">
                  <div class="option-name">
                    <input
                      #selectedWingData
                      [checked]="key.isChecked == true"
                      (change)="selectMultipleWing(i)"
                      [id]="i"
                      type="checkbox"
                    />

                    <label [for]="i" class="class-category-name-text">{{
                      key.classCategoryName
                    }}</label>
                  </div>
                </ng-container>
              </div>
            </div>

            <div class="main-container-selection">
              <div class="label-selection">
                {{ 'selectClass' | translate }}
              </div>
              <input
                (click)="openClassOption($event)"
                readonly
                [placeholder]="
                  appliedClassStandard != 'All'
                    ? appliedClassStandard.length + ' selected'
                    : ('all' | translate)
                "
                class="input-for-wing-selection"
              />
              
              <span class="dropdown-icon"><i class="ri-arrow-drop-down-line"></i></span>
              <div *ngIf="openOptionForClassSelection" class="option-for-wing">
                <ng-container *ngIf="classStandardData.length > 0">
                  <div class="option-name">
                    <input
                    [checked]="getClassStatus()"
                    (click)="selectAllClass($event)"
                      type="checkbox"
                    [id]="79"
                    />
                    <label [for]="79"  class="class-category-name-text">{{ 'all' | translate }}</label>
                  </div>
                  <ng-container
                    *ngFor="let key of classStandardData; let i = index"
                  >
                    <div class="option-name">
                      <input
                        #selectedClass
                        [checked]="key.isChecked == true"
                        (change)="selectMultipleClass(i)"
                        [id]="'class-standard' + i"
                        type="checkbox"
                      />
                      <label
                        [for]="'class-standard' + i"
                        class="class-category-name-text"
                        >{{ key.classStandardName }}</label
                      >
                    </div>
                  </ng-container>
                </ng-container>
                <div class="loader-class-data" *ngIf="loadingClassData">
                  <app-button-loader
                  [borderStyle]="'3px solid var(--brand-primary-color)'"
                ></app-button-loader>
                </div>
                <div *ngIf="classStandardData.length == 0 && !loadingClassData">
                  {{ 'all' | translate }}
                </div>
              </div>
              <div
                *ngIf="fetchingClassData"
                class="loader-container-fetch-selection"
              >
                <app-button-loader
                  [borderStyle]="'3px solid var(--brand-primary-color)'"
                ></app-button-loader>
              </div>
            </div>


            <div class="main-container-selection">
              <div class="label-selection">
                {{ 'selectSection' | translate }}
              </div>
              <input
              (click)="openOptionSectionSelectionData($event)"
                readonly
                [placeholder]="
                appliedClassId != 'All'
                  ? appliedClassId.length + ' selected'
                  : ('all' | translate)
              "
                class="input-for-wing-selection"
              />
              
              <span class="dropdown-icon"><i class="ri-arrow-drop-down-line"></i></span>
              <div *ngIf="openOptionForSectionSelection" class="option-for-wing">
                <ng-container *ngIf="classSectionData.length > 0 && !loadingSectionData">
                  <div class="option-name">
                    <input
                    [checked]="getSectionStatus()"
                    type="checkbox"
                    readonly
                    (click)="selectAllSection($event)"
                    [id]="80"
                    />
                    <label [for]="80"  class="class-category-name-text">{{ 'all' | translate }}</label>
                  </div>
                  <ng-container
                    *ngFor="let key of classSectionData; let i = index"
                  >
                    <div  class="option-name">
                      <input
                      #selectedClass
                      [checked]="key.isChecked == true"
                      (change)="selectMultipleSection(i)"
                      [id]="'class-section' + i"
                      type="checkbox"
                      />
                      <label
                        [for]="'class-section' + i"
                        class="class-category-name-text"
                        >{{key.classStandardName + " - " + key.classDivision }}</label
                      >
                    </div>
                  </ng-container>
                </ng-container>
                <div class="loader-class-data" *ngIf="loadingSectionData">
                  <app-button-loader
                  [borderStyle]="'3px solid var(--brand-primary-color)'"
                ></app-button-loader>
                </div>
                <div *ngIf="classSectionData.length == 0 && !loadingSectionData">
                  {{ 'all' | translate }}
                </div>
              </div>
              <div
                *ngIf="fetchingClassData"
                class="loader-container-fetch-selection"
              >
                <app-button-loader
                  [borderStyle]="'3px solid var(--brand-primary-color)'"
                ></app-button-loader>
              </div>
            </div>

            

            <div class="main-container-selection">
              <div class="label-selection">
                {{ 'selectCaste' | translate }}
              </div>
              <select
                [(ngModel)]="selectedCaste"
                class="selection-box-filter"
                name=""
                id=""
              >
                <option value="" [ngValue]="null" selected>
                  {{ 'all' | translate }}
                </option>
                <option *ngFor="let key of categoryData" [ngValue]="key">
                  {{ key.castCategory }}
                </option>
              </select>
            </div>

            <div class="main-container-selection">
              <div class="label-selection">
                {{ 'selectGender' | translate }}
              </div>
              <select
                [(ngModel)]="selectedGender"
                class="selection-box-filter"
                name=""
                id=""
              >
                <option value="" [ngValue]="null" selected>
                  {{ 'all'| translate }}
                </option>
                <option *ngFor="let key of genderData" [ngValue]="key">
                  {{ key.studentGender }}
                </option>
              </select>
            </div>
          </div>
          <div class="result-size-apply-filter">
            <div class="result-filter-size-heading">
              {{ resultAvailable }} {{ 'resultAvailable' | translate }}
            </div>
            <div class="apply-button-filter-category-container">
              <button
                (click)="applyFilter()"
                class="apply-button-filter-category"
              >
                {{ 'apply' |  translate }}
              </button>
            </div>
          </div>
        </div>

        <div
          (click)="collapseColumnOption()"
          class="student-count-category-wise-main-container"
        >
          <div #scrollableDiv class="student-count-category-wise">
            <div
              [ngClass]="{
                'student-count-category-wise-sub-container':
                  !isExpandStatContainerData,
                'student-count-category-wise-sub-container-active':
                  isExpandStatContainerData
              }"
            >
              <ng-container
                *ngIf="studentStatDataInfo && studentStatDataInfo.length > 0"
              >
                <ng-container *ngIf="!fetchingStatData">
                  <div
                    *ngFor="let data of studentStatDataInfo"
                    class="first-data-category-wise"
                  >
                    <div class="first-data-info-category-wise">
                      <div class="heading-container-data-category-wise">
                        {{ data.statKey }}
                      </div>
                      <div class="data-of-row-in-numbers">
                        {{ data.statValue }}
                      </div>
                    </div>

                    <div class="first-data-info-category-wise-info">
                      <div
                        *ngFor="let subData of data.subStatData"
                        class="student-info-according-data"
                      >
                        <div class="number-string-category-wise">
                          {{ subData.subStatKey }}
                        </div>
                        <div class="number-text-category-wise">
                          {{ subData.subStatValue }}
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>

              <div *ngIf="fetchingStatData" class="loader-stat-info">
                <app-button-loader
                  [borderStyle]="'3px solid var(--brand-primary-color)'"
                ></app-button-loader>
              </div>
            </div>
          </div>
          <div class="data-open-category-wise">
            <div
              (click)="openStudentStatsContainer()"
              class="data-open-category-wise-icon-container"
            >
              <img
                [ngClass]="{
              'data-open-category-wise-icon' : !isExpandStatContainerData,
              'data-open-category-wise-icon-active' : isExpandStatContainerData,
            }"
                src="../../assets/img/bottom-arrow.png"
                alt="bottom-arrow"
              />
            </div>
          </div>
          <div class="scroll-open-category-wise">
            <div
              (click)="scrollStatData('right')"
              class="data-open-category-wise-icon-container"
            >
              <img
                class="data-scroll-category-wise-icon"
                src="../../assets/img/bottom-arrow.png"
                alt="arrow"
              />
            </div>
          </div>
          <div class="scroll-open-left-category-wise">
            <div
              (click)="scrollStatData('left')"
              class="data-open-category-wise-icon-container"
            >
              <img
                class="data-scroll-left-category-wise-icon"
                src="../../assets/img/bottom-arrow.png"
                alt="arrow"
              />
            </div>
          </div>
        </div>

        <div class="table-of-student">
          <table class="table-data-category-wise">
            <thead class="category-wise-table-header">
              <tr *ngIf="tableColumnData && tableColumnData.length > 0">
                <ng-container
                  *ngFor="let tableData of tableColumnData; let index = index"
                >
                  <th *ngIf="tableData.isDefault == 1">
                    <div
                      class="selected-first-row-category"
                      (click)="expandColumnOption(index)"
                    >
                      <span>{{ tableData.columnName }}</span>
                      <span
                        ><img
                          class="row-dropdown-category"
                          src="../../assets/img/row-dropdown.png"
                          alt="arrow"
                      /></span>
                    </div>
                    <div
                      class="option-for-first-row"
                      *ngIf="columnIndex === index"
                    >
                      <div
                        class="option-for-first-row-data"
                        *ngFor="let tableInfoData of tableColumnData"
                      >
                        <span
                          ><input
                            type="checkbox"
                            (click)="
                              updateTableColumn(
                                tableData.slug,
                                tableInfoData.slug
                              )
                            "
                            id="column-name-{{ tableInfoData.slug }}"
                            [disabled]="tableInfoData.isDefault == 1"
                            [checked]="tableInfoData.isDefault == 1"
                        /></span>
                        <label
                          class="slug-labels"
                          for="column-name-{{ tableInfoData.slug }}"
                          >{{ tableInfoData.columnName }}</label
                        >
                      </div>
                    </div>
                  </th>
                </ng-container>
              </tr>
            </thead>
            <tbody
              (click)="collapseColumnOption()"
              class="category-wise-table-body"
            >
              <div class="table-info-loader" *ngIf="fetchingTableData">
                <app-button-loader
                  [borderStyle]="'3px solid var(--brand-primary-color)'"
                ></app-button-loader>
              </div>
              <ng-container *ngIf="tableRowData && tableRowData.length > 0">
                <ng-container *ngFor="let tableInfo of tableRowData">
                  <tr *ngIf="!fetchingTableData">
                    <ng-container *ngFor="let tableColumns of tableColumnData">
                      <td *ngIf="tableColumns.isDefault === 1">
                        {{ tableInfo[tableColumns.columnName] }}
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>
              </ng-container>
              <ng-container>
                <div
                  *ngIf="
                    !fetchingTableData &&
                    tableRowData && tableRowData.length === 0
                  "
                  class="no-student-data"
                >
                  {{ 'noData' |  translate }}
                </div>
              </ng-container>
            </tbody>
          </table>
        </div>

        <div
          (click)="collapseColumnOption()"
          class="result-pagination-and-length-category-wised"
        >
          <div class="length-category-wise-table">
            <span>{{ 'show' |  translate }}</span>
            <span class="reult-length-selection">
              <select
                (change)="changePageLimitData($event.target.value)"
                class="select-filter-length-category-wise"
              >
                <option value="10" selected>10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
                <option value="60">60</option>
                <option value="70">70</option>
              </select>
            </span>
          </div>
          <div class="page-switcher-category-wise">
            <div
              (click)="changePage(startingPageNumber - 1)"
              *ngIf="startingPageNumber > 1"
              class="arrow-left-page-switcher"
            >
              <i class="ri-arrow-left-s-line"></i>
            </div>
            <ng-container *ngIf="pageNumbers && pageNumbers.length > 0">
              <div
                *ngFor="let pageNumberInfo of pageNumbers"
                (click)="switchPageNumber(pageNumberInfo)"
                class="number-page-switcher"
                [ngClass]="{
                  'selected-page-switcher':
                    pageNumberInfo === startingPageNumber,
                  'selected-disabled-page-switcher': pageNumberInfo === '...'
                }"
              >
                {{ pageNumberInfo }}
              </div>
            </ng-container>

            <div
              (click)="changePage(startingPageNumber + 1)"
              *ngIf="startingPageNumber != maxPageNumber"
              class="arrow-left-page-switcher"
            >
              <i class="ri-arrow-right-s-line"></i>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
